import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux"
import {toast} from "react-toastify";
import { Navigate } from 'react-router-dom';
import { Icon, Button, ButtonGroup, Dimmer, Loader, Modal, Header, Popup } from "semantic-ui-react";
import Box from './../../components/Box/Box';
import Page from './../../components/Page/Page';
import API, {ErrorManagement, ResponseManagement} from "../../API";
import ModalPreCheckIn from "./../../components/PreCheckIn/ModalPreCheckIn";
import BookingRoomingDetail from "./../../components/PreCheckIn/BookingRoomingDetail";
import GlobalContext from "./../../contexts/GlobalContext";
import ModalTransition from "./../../components/ModalTransition/ModalTransition";
import Utility from './../../Utility';
import './PreCheckIn.css';
import useFromSelfCheckin from "../../hooks/useFromSelfCheckin";
//import IdleTimer from "react-idle-timer";
import { useIdleTimer } from 'react-idle-timer'
import ModalSuccessPreCheckin from "../../components/PreCheckIn/successSelfCheckin/ModalSuccessSelfCheckin";
import {displayToastErrorFromResponse} from "@components/TradsErrorPages/ErrorUtil";

const mapProps = (state) => ({
    bookingsCompletionRates: state.booking.bookingsCompletionRates,
    isBookerPax: state.booking.isBookerPax
});
const mapDispatch = (dispatch) => ({
    load: dispatch.booking.load,
    updateIsBookerPax: dispatch.booking.updateIsBookerPax
});

const PreCheckIn = props => {
    const [isLoadingState, setIsLoadingState] = useState(true);
    const [listResaState, setListResaState] = useState([]);
    const [listRoomsState, setListRoomsState] = useState([]);
    const [checkInFieldParametersState, setCheckInFieldParametersState] = useState([]);
    const [modalDataState, setModalDataState] = useState(false);
    const [indexResaState, setIndexResaState] = useState("");
    const [indexRoomingState, setIndexRoomingState] = useState(null);
    const [confirmState, setConfirmState] = useState({open:false, confirmIndexResa:null, confirmIndexRooming:null});
    const [bookingFolderDataState, setBookingFolderDataState] = useState({bookinFolderNumber: "", roomTotal: "", paxTotalNumber: "", completionRates: {}});
    const [globalContext] = useContext(GlobalContext);
    const [isRedirectState, setIsRedirectState] = useState(false);
    const [isRedirectDashboardState, setIsRedirectDashboardState] = useState(false);
    const [redirectLoginState, setRedirectLoginState] = useState(false);
    const [redirect404State, setRedirect404State] = useState(false);
    const [redirectInitializePasswordState, setRedirectInitializePasswordState] = useState(false);
    const [newTokenState, setNewTokenState] = useState("");
    

    const fromSelfCheckin = useFromSelfCheckin(props.location);

    // Chargement initial avec appel Ajax pour récupération des données
    useEffect(() => {
        let data = {
            isFromSelfCheckin: fromSelfCheckin.isFromSelfCheckin,
            selfCheckinToken: fromSelfCheckin.selfCheckinToken,
            bookingFolderId: props.match.params.id
        }

        setIsRedirectState(false);
        API
            .post(Utility.getUrlAjax() + `/preCheckIn-${props.match.params.id}`, JSON.stringify(data))
            .then(res => {
                ResponseManagement(res,
                    () => {
                        if (res.data.data.completionRates) {
                            // MAJ DU STORE BOOKING COMPLETION RATES
                            if (res.data.data.completionRates?.byFolder && res.data.data.completionRates.byFolder?.[parseInt(props.match.params.id)]) {
                                if (res.data.data.completionRates.byFolder[parseInt(props.match.params.id)]?.byBooking) {
                                    //maj sotre booking completion rate
                                    props.load({bookingsCompletionRates: res.data.data.completionRates.byFolder[parseInt(props.match.params.id)].byBooking});
                                }
                            }
                        }

                        let processedData = handleData(res.data.data);
                        if (processedData){
                            handleReloadData(processedData);
                            // // si email booking ou expedia
                            // if( processedData.isMailValid == false && processedData.isFromSelfCheckin == false ){
                            //     setRedirectInitializePasswordState(true);
                            //     setNewTokenState( processedData.newToken );
                            // }
                            if (processedData.bookings){
                                setListResaState(processedData.bookings);
                                setIsLoadingState(false);
                                setListRoomsState(processedData.accommodationServices);
                            }
                            if (processedData.checkInFieldParameters){
                                setCheckInFieldParametersState(processedData.checkInFieldParameters);
                            }
                            if (processedData.isBookerPax) {
                                props.updateIsBookerPax(processedData.isBookerPax);
                            }
                        }
                    },
                    () => {
                        
                        if( typeof res.data.message !== "undefined" && res.data.message !== "" ){
                            toast.error( globalContext.translations[res.data.message] );
                        }
                        else{
                            displayToastErrorFromResponse(res);
                        }

                        var timeOut = setTimeout(() => {
                            clearTimeout(timeOut);
                            if( globalContext.authenticationStatus == 1 ){
                                setIsRedirectDashboardState(true);
                            }
                            else{
                                if ( ['errorPreCheckInOldBookingFolder', 
                                        'error_unknown_bookingFolderId', 
                                        'error_authentication_session_link_expired', 
                                        'error_authentication_session_type_not_valid', 
                                        'error_authentication_session_missing_page_type', 
                                        'error_authentication_session_missing_link',
                                        'error_authentication_session_authentication_status'].includes(res.data.message) ){
                                    
                                    setRedirectLoginState(true);
                                }
                                else{
                                    // TODO
                                    setRedirect404State(true);
                                }
                            }
                        }, 5500);
                    }
                );
            })
            .catch(error => {
                console.error(error);
                ErrorManagement(error, () => {
                    var timeOut = setTimeout(() => {
                        clearTimeout(timeOut);
                        setIsRedirectDashboardState(true);
                    }, 5500);
                });
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.id]);

    // Gestion pour affichage de la modal avec des données roomingList ou non
    useEffect(() => {
        if (!modalDataState){
            setIndexRoomingState(null);
        }
    }, [modalDataState]);

  // Gestion de la suppresion d'un client de l'élément roomingList
    const handleConfirmDelete = () => {
        let dataToSend = new URLSearchParams({
            bookingId       : listResaState[confirmState.confirmIndexResa].id,
            roomingListId   : listResaState[confirmState.confirmIndexResa].roomingList[confirmState.confirmIndexRooming].id,
            bookingFolderId : props.match.params.id,
        });

        API
            .post(Utility.getUrlAjax() + '/removePreCheckInAction', dataToSend)
            .then(res => {
                ResponseManagement(res,
                    () => {
                        if (res.data.data.completionRates) {
                            // MAJ DU STORE BOOKING COMPLETION RATES
                            if (res.data.data.completionRates?.byFolder && res.data.data.completionRates.byFolder?.[parseInt(props.match.params.id)]) {
                                if (res.data.data.completionRates.byFolder[parseInt(props.match.params.id)]?.byBooking) {
                                    //maj sotre booking completion rate
                                    props.load({bookingsCompletionRates: res.data.data.completionRates.byFolder[parseInt(props.match.params.id)].byBooking});
                                }
                            }
                        }

                        let processedData = handleData(res.data.data);
                        if (processedData) {
                            if (processedData.checkInFieldParameters) {
                                setCheckInFieldParametersState(processedData.checkInFieldParameters);
                            }
                            if (processedData.bookings) {
                                handleReloadData(processedData);
                                setListResaState(processedData.bookings);
                                toast.success(globalContext.translations.preCheckInAlertDeleteSuccess);
                            }
                            if (processedData.isBookerPax) {
                                props.updateIsBookerPax(processedData.isBookerPax);
                            }
                        }
                    },
                    () => {
                        toast.error('Data sending error');
                        var timeOut = setTimeout(() => {
                            clearTimeout(timeOut);
                            setIsRedirectDashboardState(true);
                        }, 5500);
                    }
                );
            })
            .catch(error => {
                console.error(error);
                ErrorManagement(error, () => {
                    var timeOut = setTimeout(() => {
                        clearTimeout(timeOut);
                        setIsRedirectDashboardState(true);
                    }, 5500);
                });
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setConfirmState({open: false, confirmIndexResa: null, confirmIndexRooming:null});
    };

    // Gestion de l'annulation de suppression
    const handleCancelDelete = () => (setConfirmState({open: false, confirmIndexResa: null, confirmIndexRooming:null}));

    // Gestion des données récupérer lors de chaque appel Ajax pour recalcul de certaines données
    const handleReloadData = (data) => {
        if (data.bookingFolder) {

            let bookingFolderDataToUpdate = {...bookingFolderDataState};
            bookingFolderDataToUpdate.paxTotalNumber = data.bookingFolder.paxTotal;
            bookingFolderDataToUpdate.bookinFolderNumber = data.bookingFolder.number;
            bookingFolderDataToUpdate.roomTotal = data.bookingFolder.roomTotal;
            // bookingFolderDataToUpdate.globalCompletionRate = data.completionRates.global.folderList[props.match.params.id].rate;
            bookingFolderDataToUpdate.completionRates = data.completionRates;
            setBookingFolderDataState(bookingFolderDataToUpdate);
        }
    };

    // Gestion de l'ouverture de la modal et de la gestion des index pour passage données roomingList correspondant
    const handleModal = (id, indexRoomingModal = "") => {
        if (indexRoomingModal !== ""){
            setIndexRoomingState(indexRoomingModal);
        }
        const index = listResaState.map(resa => resa.id).indexOf(id);
        setIndexResaState(index);
        setModalDataState(true);
    };

    // Gestion des données récupérer lors de chaque appel Ajax pour retransformation des données au format initial
    const handleData = (data) => {
        if (data.bookings.length > 0){
            data.bookings.forEach(booking => {
                if (data.bookingPaxes.length > 0){
                    let roomingList = data.bookingPaxes.filter(pax => pax.bookingId === booking.id);
                    if (data.completionRates.length > 0 && roomingList.length > 0){
                        roomingList.forEach((roomingData) => {
                            return roomingData.completionRate = data.completionRates.find(completionRate => completionRate.bookingPaxId === roomingData.id).rate;
                        });
                    }
                    booking.roomingList = roomingList;
                }
                if (data.accommodationServices.length > 0){
                    booking.roomType = data.accommodationServices.find(accommodationService => accommodationService.id === booking.accommodationServiceId).name;
                }
                return booking;
            });
            return data;
        }
        return false;
    };

    // Affichage de la modal de confirmation de suppression
    const triggerConfirm = (id, indexRoomingModal) => {
        setConfirmState({open: true, confirmIndexResa: listResaState.map(resa => resa.id).indexOf(id), confirmIndexRooming: indexRoomingModal});
    };

    const getContent = () => {
        // Préparation tableau des types de chambres pour affichage
        let roomTypes = [];
        listResaState.forEach(resa => (roomTypes.indexOf(resa.roomType) === -1 ? roomTypes.push(resa.roomType) : ""));
        let deleteHeader = (
            <Modal.Header>
                <Header>
                    {globalContext.translations.deletionOfTheTenant}
                </Header>
            </Modal.Header>
        );
        let deleteAction = (
            <Modal.Actions>
                <Button type="button" onClick={() => handleCancelDelete()}>
                    {globalContext.translations.preCheckInCancel}
                </Button>
                <Button type="button" onClick={() => handleConfirmDelete()} color="red">
                    {globalContext.translations.preCheckInDelete}
                </Button>
            </Modal.Actions>
        );
        
        const getGlobalCompletionRate = () => {
            if(bookingFolderDataState.completionRates !== undefined && bookingFolderDataState.completionRates !== null) {
                if(bookingFolderDataState.completionRates.global !== undefined && bookingFolderDataState.completionRates.global !== null) {
                    if(bookingFolderDataState.completionRates.global.folderList !== undefined && bookingFolderDataState.completionRates.global.folderList !== null) {

                        if(bookingFolderDataState.completionRates.global.folderList[props.match.params.id] !== undefined && bookingFolderDataState.completionRates.global.folderList[props.match.params.id] !== null) {
                            return bookingFolderDataState.completionRates.global.folderList[props.match.params.id].rate;
                        }
                    }
                }
            }
        }
        
        return (
            <div>
                <div className={!fromSelfCheckin.isFromSelfCheckin ? "mt-5" : ""}>
                    <h3 className="title-mb" style={{display:'flex', padding: "0"}}>
                        <div style={{padding: "9px 5px 9px 25px"}}>
                            {globalContext.translations.titlePreCheckInPartOne} n°<strong className="mbBlue"> {bookingFolderDataState.bookinFolderNumber}</strong>. {globalContext.translations.titlePreCheckInPartTwo} <strong style={{color: "#2185d0"}}>{bookingFolderDataState.roomTotal}</strong> {globalContext.translations.titlePreCheckInPartThree} <strong style={{color: "#2185d0"}}>{bookingFolderDataState.paxTotalNumber}</strong> {globalContext.translations.titlePreCheckInPartFour}.<br /> {globalContext.translations.titlePreCheckInPartFive} <strong style={{color: "#2185d0"}}>{getGlobalCompletionRate()}%</strong>
                        </div>
                        {
                            fromSelfCheckin.isFromSelfCheckin ?
                                <Popup
                                  content={globalContext.translations.disconnect}
                                  trigger={
                                      <Button
                                        className="return-selfCheckin-action-container btnStyleDelete"
                                        icon={
                                            <Icon
                                              size="big"
                                              name="sign-out alternate"
                                            />
                                        }
                                        onClick={() =>  props.history.push(`/${fromSelfCheckin.selfCheckinToken}`)}
                                      />
                                  }
                                />
                            :
                                null
                        }

                    </h3>
                </div>
                <ModalPreCheckIn modalData={modalDataState} setModalData={setModalDataState} listResa={listResaState} indexResa={indexResaState} checkInFieldParameters={checkInFieldParametersState} setListResa={setListResaState} setCheckInFieldParameters={setCheckInFieldParametersState} bookingFolderId={props.match.params.id} handleData={handleData} setIsRedirectState={setIsRedirectState} handleReloadData={handleReloadData} indexRooming={indexRoomingState}/>
                <ModalTransition
                    header={deleteHeader}
                    content={`${globalContext.translations.preCheckInDeleteMessage} ?`}
                    actions={deleteAction}
                    open={confirmState.open}
                    size="tiny"
                    handleClose={handleCancelDelete}
                />

                <div id="cardPreCheckIn">
                    <Dimmer inverted active={isLoadingState}>
                        <Loader>{(props.match.params.lang === 'FR') ? 'Chargement' : 'Loading'}</Loader>
                    </Dimmer>
                    {showBooking()}
                </div>
            </div>
        );
    };

    // Composant des cartes de chaque réservation ainsi que des bouttons d'ajout/modification/suppresion des clients
    const showBooking = () => {
        // console.log(bookingFolderDataState.completionRates.byPax[]);
        const bookings = listResaState.map(booking => {
            // console.log(booking);
            // console.log(bookingFolderDataState);
            const addButtons = [];
            //let sumCompletationRate = 0;
            let bookingCompletionRate = 0;
            let bookingCompletionRateByPax = {};

            if(bookingFolderDataState.completionRates.byFolder !== undefined && bookingFolderDataState.completionRates.byFolder[booking.bookingFolderId] !== undefined 
                && bookingFolderDataState.completionRates.byFolder[booking.bookingFolderId].byBooking[booking.id] !== undefined) {
                    bookingCompletionRate = bookingFolderDataState.completionRates.byFolder[booking.bookingFolderId].byBooking[booking.id].rate;
                    bookingCompletionRateByPax = bookingFolderDataState.completionRates.byFolder[booking.bookingFolderId].byBooking[booking.id].detailByPax;
                }
                // console.log(bookingFolderDataState.completionRates.byFolder[booking.bookingFolderId].byBooking[booking.id]);
                
            for (let i=0; i < booking.paxTotal; i++) {
                let completionRate = 0;
                // console.log(bookingFolderDataState.completionRates.byFolder[booking.bookingFolderId].byBooking[booking.id]);
                // completionRate = bookingFolderDataState.byFolder[booking.bookingFolderId].byBooking[booking.id];
                // if(booking.roomingList[i] !== undefined && bookingFolderDataState.completionRates !== undefined && bookingFolderDataState.completionRates.byPax !== undefined && bookingFolderDataState.completionRates.byPax[booking.roomingList[i]] !== undefined ) {
                //     bookingFolderDataState.completionRates.byPax[booking.roomingList[i]]
                // }
                // if (booking.roomingList !== undefined && booking.roomingList[i] !== undefined && booking.roomingList[i].completionRate !== undefined){
                //     sumCompletationRate += booking.roomingList[i].completionRate;
                //     completionRate = booking.roomingList[i].completionRate;
                // } else {
                //     sumCompletationRate += 0;
                // }

                let indexRoomingModal = i;
                if (booking.roomingList !== undefined && booking.roomingList[i] !== undefined){
                    let colorCompletionRate = "";
                    let idUser = 0;
                    
                    if(booking.roomingList[i].id !== undefined) {
                        idUser = booking.roomingList[i].id;
                        if(typeof bookingCompletionRateByPax !== 'undefined') {
                            if(typeof bookingCompletionRateByPax[idUser] !== 'undefined') {
                                completionRate = bookingCompletionRateByPax[idUser].rate;
                            }
                        }
                    }

                    if (completionRate === 100) {
                        colorCompletionRate = "green";
                    } else if (completionRate > 33) {
                        colorCompletionRate = "orange";
                    } else {
                        colorCompletionRate = "red";
                    }
                    addButtons.push(
                        <ButtonGroup className="btnGroup" key={i} style={{width: "100%"}}>
                            <Button style={{width: "85%"}} icon labelPosition="left" className="btnStyle" basic color="black" animated="vertical" onClick={() => handleModal(booking.id, indexRoomingModal)}>
                                <Icon style={{width: "17.5%"}} name="user" size="large"/>
                                <Button.Content><p style={{color: "black", marginBottom:"0px"}}>{booking.roomingList[i].civility} {booking.roomingList[i].lastName} {booking.roomingList[i].firstName}</p><p style={{color: colorCompletionRate}}>complété à {completionRate}%</p></Button.Content>
                            </Button>
                            <Button style={{width: "15%"}} className="btnStyleDelete" basic color="black" onClick={() => triggerConfirm(booking.id, indexRoomingModal)}>
                                <Icon style={{width: "15%"}} name="trash" size="large"/>
                            </Button>
                        </ButtonGroup>
                    )
                } else {
                    addButtons.push(
                        <ButtonGroup className="btnGroup" key={i} style={{width: "100%"}}>
                            <Button icon labelPosition="left" className="btnStyle" color="black" basic animated="vertical" onClick={() => handleModal(booking.id)}>
                                <Icon style={{width: "15%", color: "#fbbd08"}} name="add user" size="large" />
                                <Button.Content style={{color: "#fbbd08"}}>{globalContext.translations.preCheckInAdd}</Button.Content>
                            </Button>
                        </ButtonGroup>
                    )
                }
            }

            // if (sumCompletationRate !== 0){
            //     bookingCompletionRate = Math.round(sumCompletationRate/booking.paxTotal, 2);
            // }

            let preCheckInMessage = globalContext.translations.preCheckInMessage;
            let colorGlobalCompletionRate = "";
            let preCheckInAddMessage = "";

            if (bookingCompletionRate === 100){
                colorGlobalCompletionRate = "#2185d0";
            } else if (bookingCompletionRate > 33){
                colorGlobalCompletionRate = "orange";
                preCheckInAddMessage = globalContext.translations.preCheckInAddMessage;
            } else {
                colorGlobalCompletionRate = "red";
                preCheckInAddMessage = globalContext.translations.preCheckInAddMessage;
            }

            let detailsRoom = {}
            for(let[, detailsRoomTemp] of Object.entries(listRoomsState)) {
                if (detailsRoomTemp.id === booking.accommodationServiceId) {
                    detailsRoom = detailsRoomTemp;
                    break;
                }
            }
            
            return <BookingRoomingDetail key={booking.id} booking={booking} preCheckInMessage={preCheckInMessage} preCheckInAddMessage={preCheckInAddMessage} bookingCompletionRate={bookingCompletionRate} colorGlobalCompletionRate={colorGlobalCompletionRate} addButtons={addButtons} detailsRoom={detailsRoom}/>
        });
        return bookings
    };

    // Redirection pour rechargement de la page de checkin lors d'un echec d'ajout ou de modification
    const isRedirectCheckIn = () => {
        if (isRedirectState){
            setIsRedirectState(false);
            return <Navigate to={{ pathname: `/${props.match.params.token}/${props.match.params.lang}/checkin/${props.match.params.id}`, state: { from: props.location } }} />
        } else {
            return null;
        }
    };

    // Redirection au dashnboard en cas d'erreur de chargement de la page preCheckIn
    const isRedirectDashboard = () => {
        if (isRedirectDashboardState){
            return <Navigate to={{ pathname: `/${props.match.params.token}/${props.match.params.lang}/`, state: { from: props.location } }} />
        } else {
            return null;
        }
        //return isRedirectDashboardState ? <Redirect to={{ pathname: `/${props.match.params.token}/${props.match.params.lang}/`, state: { from: props.location } }} /> : null
    };

    const renderRedirect404 = () => {
        if (redirect404State) {
            window.location.href = "/";
        }
    }

    const renderRedirectLogin = () => {
        if (redirectLoginState) {
            let url = "/" + props.match.params.token + "/" + props.match.params.lang +"/login";
            window.location.href = url;
            //return <Navigate to={url} />
        }
    }

    const renderRedirectInitializePassword = () => {
        if ( redirectInitializePasswordState && newTokenState != "" ) {
            return <Navigate to={{ pathname: `/${newTokenState}/${props.match.params.lang}/login/initializePassword`, state: { from: props.location } }} />
            /*let url = "/" + newTokenState + "/" + props.match.params.lang +"/login/initializePassword";
            window.location.href = url;*/
            //return <Navigate to={url} />
        }
    }

    const onIdle = () => {
        // Close Modal Prompt
        // Do some idle action like log out your user
        props.history.push(`/${fromSelfCheckin.selfCheckinToken}`)
    }

    const idleTimer = useIdleTimer({  onIdle,
        startOnMount : false,
        debounce : 250,
    });

    /*{fromSelfCheckin.isFromSelfCheckin ?
        <IdleTimer
        element={document}
        onIdle={() =>  props.history.push(`/${fromSelfCheckin.selfCheckinToken}`)}
        debounce={250}
        timeout={ 2 * 1000 * 60}
        />
        :
        null
    }*/
    
    return (
        <Page location={props.location} history={props.history}>
            
            <Box header="">
                {renderRedirectInitializePassword()}
                {isRedirectCheckIn()}
                {isRedirectDashboard()}
                {renderRedirectLogin()}
                {renderRedirect404()}
                {getContent()}
            </Box>
            <ModalSuccessPreCheckin />
        </Page>
    )
};

export default connect(mapProps, mapDispatch)(PreCheckIn);